var _svg;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TalentDark = function TalentDark(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _svg || (_svg = /*#__PURE__*/_jsx("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsxs("g", {
        fill: "#49F2E1",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M11.9 9.875a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        }), /*#__PURE__*/_jsx("path", {
          opacity: ".4",
          d: "M19.8 21.775H4v-2.6c0-4.4 3.6-7.9 7.9-7.9 4.4 0 7.9 3.6 7.9 7.9v2.6Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "m11.9 18.175-1.7.9.3-1.9-1.3-1.3 1.9-.2.8-1.7.8 1.7 1.9.2-1.3 1.3.3 1.9-1.7-.9Z"
        })]
      })
    }))
  });
};
export default TalentDark;